import { chatIcons, contactIcons, shellIcons } from "./paths.generated";

// Íconos con la misma geometría y atributos que ChatIcon, ContactIcon y ShellIcon del portal actual. La geometría viene
// de scripts/generate-icons.py (texto fijo del repositorio, nunca datos de la persona), por eso se inserta tal cual.

const viewBox = (name: string) => (name === "whatsapp" ? "0 0 720 720" : "0 0 24 24");

/** Íconos de Lucide que el generador no trae (E62), con su trazo; nunca un hueco donde va un ícono. */
const extraChatIcons: Record<string, string> = {
  "archive-restore":
    '<rect width="20" height="5" x="2" y="3" rx="1"></rect><path d="M4 8v11a2 2 0 0 0 2 2h2"></path><path d="M20 8v11a2 2 0 0 1-2 2h-2"></path><path d="m9 15 3-3 3 3"></path><path d="M12 12v9"></path>',
  columns: '<rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="M12 3v18"></path>',
  // Archivos del chat (imagen, video, audio, documento, nota de voz y sus estados), trazos de Lucide.
  mic: '<path d="M12 19v3"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><rect x="9" y="2" width="6" height="13" rx="3"></rect>',
  image:
    '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect><circle cx="9" cy="9" r="2"></circle><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>',
  video:
    '<path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path><rect x="2" y="6" width="14" height="12" rx="2"></rect>',
  music:
    '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
  "file-text":
    '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path>',
  "file-x":
    '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="m14.5 12.5-5 5"></path><path d="m9.5 12.5 5 5"></path>',
  pause:
    '<rect x="14" y="4" width="4" height="16" rx="1"></rect><rect x="6" y="4" width="4" height="16" rx="1"></rect>',
  "trash-2":
    '<path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line>',
  "rotate-ccw": '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path>',
  // Enviar en todo el portal (C02 y C56 1.14.11): send-horizontal de Lucide, el dibujo de las referencias. «send» (el
  // avión inclinado) ya no existe en el componente: ningún botón Enviar lo puede usar.
  "send-horizontal":
    '<path d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z"></path><path d="M6 12h16"></path>',
  // Menú del clip, tarjeta del documento y reproductor (Chat con archivos R2), trazos de Lucide.
  camera:
    '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path><circle cx="12" cy="13" r="3"></circle>',
  headphones:
    '<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"></path>',
  file: '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path>',
  "file-spreadsheet":
    '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M8 13h2"></path><path d="M14 13h2"></path><path d="M8 17h2"></path><path d="M14 17h2"></path>',
  presentation:
    '<path d="M2 3h20"></path><path d="M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"></path><path d="m7 21 5-5 5 5"></path>',
  play: '<polygon points="6 3 20 12 6 21 6 3"></polygon>',
  // Cuadro de texto (C56) y menú ⋮ de la conversación (C02 1.14.10: un ícono por opción), trazos de Lucide. El
  // generador lee los íconos del portal Blazor, que no se toca: van aquí, como los demás que no trae (E62).
  "calendar-plus":
    '<path d="M8 2v4"></path><path d="M16 2v4"></path><path d="M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"></path><path d="M3 10h18"></path><path d="M16 19h6"></path><path d="M19 16v6"></path>',
  smile:
    '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" x2="9.01" y1="9" y2="9"></line><line x1="15" x2="15.01" y1="9" y2="9"></line>',
  inbox:
    '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
};

/** ChatIcon: trazo 1,75 y clase chat-r2-icon. Con `sprite`, apunta al símbolo del sprite de la lista. */
export function ChatIcon({ name, className, sprite }: { name: string; className?: string; sprite?: boolean }) {
  const classes = className ? `chat-r2-icon ${className}` : "chat-r2-icon ";
  const common = {
    className: classes,
    viewBox: viewBox(name),
    "aria-hidden": true,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  } as const;
  if (sprite)
    return (
      <svg {...common}>
        <use href={`#chat-icon-${name}`} />
      </svg>
    );
  return <svg {...common} dangerouslySetInnerHTML={{ __html: chatIcons[name] ?? extraChatIcons[name] ?? "" }} />;
}

/** ContactIcon: los íconos propios de Contactos (misma caja y trazo que ChatIcon). */
export function ContactIcon({ name }: { name: string }) {
  return (
    <svg
      className="chat-r2-icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: contactIcons[name] ?? "" }}
    />
  );
}

/** ShellIcon: íconos del encabezado y el menú (trazo 2). Sin clase propia lleva shell-icon, como en el portal actual. */
export function ShellIcon({ name, className = "shell-icon" }: { name: string; className?: string }) {
  return (
    <svg
      className={className}
      viewBox={viewBox(name)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      dangerouslySetInnerHTML={{ __html: shellIcons[name] ?? "" }}
    />
  );
}

/** Sprite de los íconos del chat: una vez por lista; las filas usan <use>. */
export function ChatIconSprite() {
  return (
    <svg
      className="chat-icon-sprite"
      aria-hidden="true"
      focusable="false"
      width="0"
      height="0"
      style={{ position: "absolute", overflow: "hidden" }}
    >
      <defs
        dangerouslySetInnerHTML={{
          __html: Object.entries(chatIcons)
            .map(([name, paths]) => `<symbol id="chat-icon-${name}" viewBox="${viewBox(name)}">${paths}</symbol>`)
            .join(""),
        }}
      />
    </svg>
  );
}
